import { useContext } from 'react';
import { APP_ROUTES } from '@/config/constants';
import { Link, useNavigate } from 'react-router-dom';
import { GenericTrackTypes } from '@/types/genericTrackTypes';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useAnalytics } from '@/hooks/useAnalytics';
import {
  BodyMedium,
  NavBarBackButton,
  BodySmallMidEmphasis,
  BodyLargeMidEmphasis,
} from '@/design-system';
import colors from '@/theme/colors';
import styles from './Preference.styles';
import UserPreferencesContext from '@/context/UserPreferencesContext';
import { Translate } from '@/components';

export const Preference: React.FC = () => {
  const { track } = useAnalytics();
  const navigate = useNavigate();
  const { language } = useContext(UserPreferencesContext);
  const list = [
    {
      label: 'Language',
      route: APP_ROUTES.language,
    },
    {
      label: 'Notifications',
      route: APP_ROUTES.notifications,
    },
    {
      label: 'Community',
      route: APP_ROUTES.community,
    },
  ];

  const onBackButtonClick = () => navigate(APP_ROUTES.account);

  return (
    <>
      <NavBarBackButton trackId="preference_page" onClickBackButton={onBackButtonClick}>
        Preference
      </NavBarBackButton>
      <div className={styles.container}>
        {list.map(({ label, route }) => (
          <Link
            className={styles.preferenceItem}
            to={route}
            aria-label={label === 'Language' ? `Go to Language page, ${language.name} selected` : `Go to ${label} page`}
            onClick={() => {
              track({
                action: GenericTrackTypes.LINK_PRESSED,
                category: 'account_page:navigation',
                label,
              });
            }}
            data-testid={`preference${label}`}
            key={label}
          >
            <div className={styles.content} data-testid={`preference${label}Content`}>
              <BodyLargeMidEmphasis data-testid={`preference${label}Label`}>
                {label}
              </BodyLargeMidEmphasis>
            </div>
            <div className={styles.buttonContainer}>
              {label === 'Language' && (
                <div className={styles.language}>
                  <BodySmallMidEmphasis data-testid="selectedLanguage" color={colors.slate}>
                    {language.name}
                  </BodySmallMidEmphasis>
                </div>
              )}

              <span
                aria-hidden="true"
                data-testid={`preference${label}ArrowIcon`}
                className={styles.arrowIcon}
              >
                <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
};
